import React, { useState, useEffect } from "react";
import { fetchMovies } from "./fetchMovies";
import MovieCard, { WithNewLabel } from "./MovieCard";
import Spinner from "./Spinner";

const Body = () => {
  const [currPage, setCurrPage] = useState(1);
  const [mainList, setMainList] = useState([]);
  const { movies, loading } = fetchMovies(currPage);

  useEffect(() => {
    setMainList((prevMovies) => [...prevMovies, ...movies]);
  }, [movies]);

  const fetchMoreData = () => {
    if (!loading) {
      setCurrPage((prevPage) => prevPage + 1);
    }
  };

  let debounceTimer;
  const handleScroll = () => {
    if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(fetchMoreData, 200);
    }
  };

  const isNewMovie = (obj) => {
    const dateString = obj?.release_date;
    const [year, month] = dateString
      .split("-")
      .map((part) => parseInt(part, 10));
    const currYear = new Date().getFullYear();
    if (year === currYear && month > 2) return true; // if it's released in this year and after february
    return false;
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="container mx-auto">
      <div className="flex flex-wrap flex-row gap-[16px] justify-evenly">
        {mainList &&
          mainList.map((movie) => {
            const NewLabel = WithNewLabel(MovieCard);
            console.log(movie);
            if (isNewMovie(movie)) {
              return <NewLabel key={movie.id} info={movie} />; // this here is the full technic how to pass props to higher-order component
            } else {
              return <MovieCard key={movie.id} info={movie} />;
            }
          })}
      </div>
      <div className="mt-[8px]">{loading && <Spinner />}</div>
    </div>
  );
};

export default Body;
